import { render } from "./PrivacyPolicy.vue?vue&type=template&id=a76220ea&scoped=true&ts=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=a76220ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a76220ea"]])

export default __exports__